export const NFC = {
    SET_ITEMS: 'SET_NFC_ITEMS',
    ADD_ITEMS: 'ADD_NFC_ITEMS',
    RESET_ITEMS: 'NFC_RESET_ITEMS',

    SET_PAGE: 'SET_NFC_PAGE',
    SET_NB_OF_PAGES: 'SET_NFC_NB_OF_PAGES',
    SET_SCROLL: 'SET_NFC_SCROLL',

    ADD_NFC_FILTER_SITE: 'ADD_NFC_FILTER_SITE',
    REMOVE_NFC_FILTER_SITE: 'REMOVE_NFC_FILTER_SITE',

    SET_NFC_FILTER_SITE: 'SET_NFC_FILTER_SITE',
    SET_FILTER_NUMERONFC: 'SET_NFC_FILTER_NUMERONFC',
    SET_FILTER_LOCALISATION: 'SET_NFC_FILTER_LOCALISATION',

    SET_NFC_FILTER_GROUPE: 'SET_NFC_FILTER_GROUPE',

    SET_SORT: 'SET_SORT',
    SET_COUNT: 'SET_NFC_COUNT',

    SET_ERROR: 'SET_NFC_ERROR',
    SET_IS_LOADING: 'SET_NFC_IS_LOADING',

    RESET: 'RESET_NFC',

    SET_HISTORIQUE: 'SET_HISTORIQUE',
    ADD_HISTORIQUE: 'ADD_HISTORIQUE',
    SET_NUMERO_NFC: 'SET_NUMERO_NFC',
    SET_HISTORIQUE_SORT: 'SET_NFC_HISTORIQUE_SORT',
    SET_HISTORIQUE_SCROLL: 'SET_HISTORIQUE_SCROLL',
    SET_NB_OF_HISTORIQUE_PAGES: 'SET_NB_OF_HISTORIQUE_PAGES',
    SET_HISTORIQUE_PAGE: 'SET_HISTORIQUE_PAGE',
    SET_HISTORIQUE_IS_LOADING: 'SET_HISTORIQUE_IS_LOADING',
    RESET_HISTORIQUE: 'RESET_HISTORIQUE',

    SET_EXPORT_XLS_IS_LOADING: 'SET_NFC_IS_LOADING'
};
